import {
  GET_ACTORS,
  GET_LIST_OF_TEAM,
  GET_TARGETS,
} from '../../constants/ActionTypes';

const initialState = {
  actors: null,
  targets: null,
  listOfTeam: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTORS:
      return {
        ...state,
        actors: action.error ? null : action.payload,
      };
    case GET_LIST_OF_TEAM:
      return {
        ...state,
        listOfTeam: action.error ? null : action.payload,
      };
    case GET_TARGETS:
      return {
        ...state,
        targets: action.error ? null : action.payload,
      };
    default:
      return state;
  }
};
